import { OptionSelector, PageSection, PageWrapper } from '@src/components';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CurrentView, HistoryView } from './components';
import { useTranslation } from 'react-i18next';

type TabKey = 'current' | 'history';

export function MyEsims() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') as TabKey | null;

  const [activeTab, setActiveTab] = useState<TabKey>('current');

  const tabOptions: TabKey[] = ['current', 'history'];

  useEffect(() => {
    if (tabParam === 'current' || tabParam === 'history') {
      setActiveTab(tabParam);
    } else {
      setSearchParams({ tab: 'current' });
    }
  }, [tabParam, setSearchParams]);

  const handleTabChange = (key: TabKey | null) => {
    if (!key) return;
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  return (
    <PageWrapper title={t('pages.myEsims.title')}>
      <PageSection className='bg-wl-background py-2 sm:py-4 sm:px-6 mb-4 sm:mb-6'>
        <OptionSelector<TabKey>
          options={tabOptions}
          selected={activeTab}
          onSelect={handleTabChange}
          className='md:[&>*]:w-[165px] [&>*]:w-full !pr-0'
          renderLabel={(key) =>
            key === 'current' ? 'Current eSIMs' : 'History'
          }
        />
      </PageSection>

      {activeTab === 'current' ? <CurrentView /> : <HistoryView />}
    </PageWrapper>
  );
}
